import { ImageComponent } from 'BreetComponents';
import { type IDropDownItem } from 'BreetHelpers';

const DropdownItemAssets = ({ item }: { item: IDropDownItem }) => (
	<>
		<span className='dropdown_content_item_options_item_name'>{item.code}</span>
		<span className='dropdown_content_item_options_item_flag'>
			<ImageComponent src={item.icon as string} />
		</span>
	</>
);

export default DropdownItemAssets;
